var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#FBEBE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 45.5H23c-.69 0-1.25-.56-1.25-1.25v-22.5c0-.69.56-1.25 1.25-1.25h20c.69 0 1.25.56 1.25 1.25v22.5c0 .69-.56 1.25-1.25 1.25zm-13.75-20a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM28 33a1.25 1.25 0 1 0 0 2.5h10a1.25 1.25 0 1 0 0-2.5H28zm0 5a1.25 1.25 0 1 0 0 2.5h10a1.25 1.25 0 1 0 0-2.5H28zm7.5-11.25a1.25 1.25 0 1 0 0 2.5H38a1.25 1.25 0 1 0 0-2.5h-2.5z",
    fill: "#FF5958"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIcon);
export default __webpack_public_path__ + "static/media/BookIcon.cd6ef48592c6916d271ec218889299eb.svg";
export { ForwardRef as ReactComponent };